import { isMobileScreen, isXxlScreen } from './utils';

const setColumns = (featuresList, featuresListItems) => {
  const numberOfItems = featuresListItems?.length;

  if (isMobileScreen() || !numberOfItems) return;

  // If it's not an XXL screen, we limit the columns to 2
  // otherwise we calculate based on the number of items
  const columnsCount = isXxlScreen()
    ? Math.min(numberOfItems, 3)
    : Math.min(numberOfItems, 2);

  featuresList.style.gridTemplateColumns = `repeat(${columnsCount}, 1fr)`;
};

const hasMoreItems = (slicedList, endPosition) =>
  slicedList.length >= endPosition;

const loadItems = (list) =>
  list?.forEach((item) => item?.classList?.remove('hidden'));

const featureLoader = (startPostion, endPosition, featuresList) => {
  const slicedList = Array.from(featuresList)?.splice(
    startPostion,
    endPosition
  );
  const hasMore = hasMoreItems(slicedList, endPosition);

  loadItems(slicedList);

  return hasMore;
};

const setItemsHeight = (items) => {
  let maxHeight = 0;
  Array.from(items?.children)?.forEach((el) => {
    const currentElementHeight = el?.getBoundingClientRect();
    maxHeight =
      maxHeight > currentElementHeight.height
        ? maxHeight
        : currentElementHeight.height;
  });

  Array.from(items?.children)?.forEach((el) => {
    el.style.height = `${maxHeight}px`;
  });
};

const setPElementsDisplay = () => {
  const pElementsWithDirectLinkChild = document.querySelectorAll(
    '.features-list_btn-container > p'
  );
  pElementsWithDirectLinkChild.forEach((p) => {
    if (p.querySelector('a')) {
      p.style.display = 'initial';
    }
  });
};

const onFeaturesListLoad = () => {
  const featuresListContainer = document.querySelectorAll(
    '[data-features-list]'
  );

  if (!featuresListContainer?.length < 0) return;

  Array.from(featuresListContainer)?.forEach((item) => {
    const featuresList = item.querySelector('[data-features-list-items]');
    const featuresListItems = featuresList.querySelectorAll(
      '.features-list_item'
    );
    const loadMoreBtn = item.querySelector('[data-features-load-btn]');

    const pagination = Number(
      item.getAttribute(
        isMobileScreen() ? 'data-mobile-pagination' : 'data-desktop-pagination'
      )
    );

    window.addEventListener('resize', () => setColumns(featuresList, featuresListItems));

    featureLoader(0, pagination, featuresListItems);
    setColumns(featuresList, featuresListItems);
    setItemsHeight(featuresList);
    setPElementsDisplay();

    if (featuresListItems.length <= pagination) return;
    let counter = pagination;
    loadMoreBtn.classList.remove('hidden');

    loadMoreBtn.addEventListener('click', () => {
      const hasMoreItems = featureLoader(
        counter,
        pagination,
        featuresListItems
      );
      counter += pagination;

      if (!hasMoreItems) loadMoreBtn.classList.add('hidden');
    });
  });
};

export default onFeaturesListLoad;
